import { render } from "./SanView.vue?vue&type=template&id=13a9c344&scoped=true"
import script from "./SanView.vue?vue&type=script&lang=js"
export * from "./SanView.vue?vue&type=script&lang=js"

import "./SanView.vue?vue&type=style&index=0&id=13a9c344&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Евадент\\eva\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a9c344"]])

export default __exports__